import { ApolloLink } from '@apollo/client';
import { sendApolloRequestAsLog, sendApolloResponseAsLog } from '@upheal/utils/logger';

export const logLink = new ApolloLink((operation, forward) => {
    sendApolloRequestAsLog(operation);

    return forward(operation).map((response) => {
        sendApolloResponseAsLog(operation, response.errors);

        return response;
    });
});
